<template>
    <nav class="navigation-component" :class="{ sticky: isSticky }">
        <div class="container">
            <div class="nav-container">
                <ul class="nav-menu">
                    <li v-for="item in navItems" :key="item.id" class="nav-item"
                        :class="{ active: activeSection === item.id }">
                        <a href="#" class="nav-link" :class="{ active: activeSection === item.id }"
                            @click.prevent="handleNavClick(item.id)">
                            {{ item.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'NavigationComponent',
    props: {
        isSticky: {
            type: Boolean,
            default: false
        },
        activeSection: {
            type: String,
            default: 'sylvia-braun'
        }
    },
    data() {
        return {
            navItems: [
                { id: 'sylvia-braun', label: 'Sylvia Braun' },
                { id: 'projects', label: 'Projekte' },
                { id: 'ask-questions', label: 'Fragen stellen' }
            ]
        }
    },
    methods: {
        handleNavClick(sectionId) {
            this.$emit('navigate', sectionId)
        }
    }
}
</script>